import React from 'react';
import { useNavigate } from 'react-router-dom';
// Mui components
import { Box, Button } from '@mui/material';

function FooterSolicitarModificacion({
  selectedEspecializaciones,
  cambiosRealizados,
  handleOpenModalEnviarModificacion
}) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        paddingX: '13em',
        bottom: 0,
        position: 'relative',
        width: '100%',
        height: '7em',
        paddingY: '2em',
        gap: 2,
        bgcolor: '#FFF'
      }}>
      <Button variant="outlined" sx={{ display: 'flex', width: '20%' }} onClick={() => navigate(-1)}>
        Volver
      </Button>
      <Button
        variant="contained"
        onClick={() => handleOpenModalEnviarModificacion()}
        disabled={
          selectedEspecializaciones.every((especialidad) => !especialidad.solicitada) ||
          !cambiosRealizados
        }
        sx={{ display: 'flex', width: '20%' }}>
        Enviar
      </Button>
    </Box>
  );
}

export default FooterSolicitarModificacion;
